import(/* webpackMode: "eager" */ "/root/repo/src/app/settings/subscriptions/page.tsx");
